import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCheck, faRupeeSign, faShippingFast, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import Alert from 'react-s-alert';
import moment from 'moment';

const InsuranceDetails = {
    PolicyNumber: "",
    Remarks: "",
    UploadedFilePath: "",
};

const Insurance = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [InsuranceData, setInsuranceData] = useState(InsuranceDetails);
    const [Customers, setCustomers] = useState([]);
    const [FilterCustomers, setFilterCustomers] = useState([]);
    const [SelectedCustomer, setSelectedCustomer] = useState({});
    const [ShowPartnerInfo, setShowPartnerInfo] = useState("none");
    const [displayFile, setdisplayFile] = useState("none");
    const [InsuranceFile, setInsuranceFile] = useState(null);
    const [FileData, setFileData] = useState(null);

    useEffect(() => {
        FetchInsuredCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchInsuredCustomers = () => {
        Axiosfetch(baseURL + "GetInsuredCustomers", "POST", {
            startDate: moment().add(1, 'days').startOf('day').utc(),
            endDate: moment().add(1, 'days').endOf('day').utc()
        }, InsuredCustomerSuccess, Failure);
    };

    const InsuredCustomerSuccess = (data) => {
        if (data.length > 0) {
            setCustomers(data);
            setFilterCustomers(data);
        }
        else {
            setCustomers([]);
            setFilterCustomers([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const onUsersSearch = (searchValue) => {
        if (searchValue !== "") {
            let SearchData = Customers.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterCustomers(SearchData);
        }
        else {
            setFilterCustomers(Customers);
        }
    };

    const GetCustomerDetails = (customer) => {
        setSelectedCustomer(customer);
        if (customer.CustomerInsurance.length > 0) {
            const InsuranceData = {
                PolicyNumber: customer.CustomerInsurance[0].PolicyNumber,
                Remarks: customer.CustomerInsurance[0].Remarks,
                UploadedFilePath: customer.CustomerInsurance[0].UploadedFilePath,
            };

            setInsuranceData(InsuranceData);
        }
        else {
            setInsuranceData(InsuranceDetails);
        }
    };

    const GetPartnerInfo = () => {
        setShowPartnerInfo(ShowPartnerInfo === "none" ? "block" : "none");
    };

    const onTextChange = (e) => {
        setInsuranceData({ ...InsuranceData, [e.target.name]: e.target.value });
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg" || selectedFile.type === "application/pdf") {
            setInsuranceFile(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SaveInsuranceDetails = () => {
        if (InsuranceFile !== null) {
            UploadInsuranceFile();
        }
        else {
            if (Customers.length > 0 && Customers[0].CustomerInsurance.length > 0 &&
                Customers[0].CustomerInsurance[0].UploadedFilePath !== "") {
                SaveInsurance(null);
            }
            else {
                Alert.error("Please attach Policy Document.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const UploadInsuranceFile = () => {
        let formData = new FormData();
        formData.append('file', InsuranceFile);
        Axiosfetch(baseURL + "UploadInsuranceFile", "POST", formData, InsuranceUploadSuccess, Failure);

    };

    const InsuranceUploadSuccess = (data) => {
        if (data.success) {
            SaveInsurance(data.filename);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const ValidateInsurance = () => {
        var errorMsg = "";
        if (InsuranceData.PolicyNumber === "") {
            errorMsg = "Please enter Policy Number.";
        }

        if (errorMsg !== "") {
            Alert.error(errorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            return false;
        }

        return true;
    };

    const SaveInsurance = (filename) => {
        if (ValidateInsurance()) {
            var insurance = InsuranceData;
            if (filename !== null) {
                insurance.UploadedFilePath = filename;
            }

            insurance.Amount = SelectedCustomer.InsuranceAmount;
            insurance.Type = SelectedCustomer.InsuranceType;
            insurance.CustomerID = SelectedCustomer._id;
            if (SelectedCustomer.CustomerInsurance.length > 0) {
                insurance._id = SelectedCustomer.CustomerInsurance[0]._id;
            }

            Axiosfetch(baseURL + (SelectedCustomer.CustomerInsurance.length > 0 ? "EditInsurance" : "CreateInsurance"), "POST", insurance, InsuranceDetailsSuccess, Failure);
        }
    };

    const InsuranceDetailsSuccess = (data) => {
        if (data.success) {
            FetchInsuredCustomers();
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const GetInsuranceFile = (Filename) => {
        if (Filename !== null) {
            Axiosfetch(baseURL + "GetInsuranceFile", "POST", { fileName: Filename }, FileSuccess, Failure);
        }
    };

    const FileSuccess = (data) => {
        if (data.success) {
            setFileData(data.fileData);
            setdisplayFile("block");
        }
    };

    const hideFileModal = () => {
        setdisplayFile("none");
    };

    const RemoveInsuranceFile = () => {
        setInsuranceFile(null);
        setInsuranceData({ ...InsuranceData, "UploadedFilePath": "" });
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Manage Insurance</h5>
                    </div>
                </div>
                <div className="col-md-12" style={{ height: "78vh" }}>
                    <div className="row" style={{ marginLeft: "5px", marginRight: "5px", height: "70vh" }}>
                        <div className="col-md-5" style={{
                            borderRight: "1px solid #ccc",
                            borderTop: "1px solid #ccc"
                        }}>
                            <div style={{ marginBottom: "20px", position: "relative" }}>
                                <input type="text" name="Name" placeholder="Search Customer..."
                                    className="input-control" style={{ outline: "none", marginRight: "10px", borderRadius: "20px", paddingLeft: "40px", borderTop: "none", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
                                    onChange={e => onUsersSearch(e.target.value)}></input>
                                <div className={`${CurrentTheme}Color`} style={{ fontSize: "1.1rem", position: "absolute", left: "89%", top: "13%" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <div style={{ height: "65vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                {FilterCustomers.length > 0 && FilterCustomers.map(customer => (
                                    <div className="UserList" key={customer._id} onClick={() => GetCustomerDetails(customer)} style={{
                                    }}>{customer.Name}
                                        {(SelectedCustomer._id !== undefined && SelectedCustomer._id === customer._id) && (<span style={{ float: "right", color: "green" }}>
                                            <FontAwesomeIcon icon={faCheck} />
                                        </span>)}
                                    </div>
                                ))}
                                {FilterCustomers.length === 0 && (<div style={{ position: "absolute", top: "50%", left: "35%", width: "40%" }}>
                                    <div style={{ padding: "10px", backgroundColor: "#ccc", textAlign: "center" }}> No Insurance Pending...</div>
                                </div>)}
                            </div>
                        </div>
                        <div className="col-md-7" style={{
                            borderL: "1px solid #ccc",
                            borderTop: "1px solid #ccc", paddingTop: "10px"
                        }}>
                            <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                <div style={{ borderBottom: "1px solid #ccc", paddingBottom: "10px" }} className="col-md-7 col-sm-7 align-right">Insurance Details</div>
                                <div style={{ borderBottom: "1px solid #ccc" }} className="col-md-5 col-sm-5 align-right">
                                    {SelectedCustomer._id !== undefined && (<span className={`${CurrentTheme}Color`} onClick={SaveInsuranceDetails} style={{ fontSize: "1.4rem", cursor: "pointer" }}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faSave} /></span>)}
                                </div>
                                <div style={{ paddingBottom: "10px", marginBottom: "5px", height: "68vh", overflow: "auto" }} className="col-md-12 col-sm-12 col-sm-12">
                                    {SelectedCustomer.Name !== undefined && (<table className="table">
                                        <tbody>
                                            <tr>
                                                <td>Name</td>
                                                <td> {SelectedCustomer.Name}</td>
                                            </tr>
                                            <tr>
                                                <td>EmailID</td>
                                                <td> {SelectedCustomer.EmailID}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone</td>
                                                <td>  {SelectedCustomer.PhoneNumber}</td>
                                            </tr>
                                            <tr>
                                                <td>Partner</td>
                                                <td> {SelectedCustomer.Partner.length === 0 ? "-" : SelectedCustomer.Partner[0].Name}
                                                    <span className={`${CurrentTheme}Color`} style={{ fontSize: "1.2rem", float: "right", cursor: "pointer" }} onClick={GetPartnerInfo}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faShippingFast}></FontAwesomeIcon></span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Amount</td>
                                                <td>
                                                    <span style={{ fontSize: "1.2rem" }}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faRupeeSign} />
                                                        {SelectedCustomer.InsuranceAmount} /-</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Type</td>
                                                <td>
                                                    <select disabled className="DropdownStyle" name="InsuranceType" value={SelectedCustomer.InsuranceType}>
                                                        <option key={0} value="0">Select Type</option>
                                                        <option key={1} value="1">Transit Risk</option>
                                                        <option key={2} value="2">Carrier Risk</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Address</td>
                                                <td>{SelectedCustomer.OriginAddress},  {SelectedCustomer.OriginCity},
                                                    {SelectedCustomer.OriginState},{SelectedCustomer.OriginPincode},
                                                    {SelectedCustomer.OriginCountry}</td>
                                            </tr>
                                            <tr>
                                                <td>Policy Number<span className="mandatoryStar">*</span></td>
                                                <td><input value={InsuranceData.PolicyNumber} name="PolicyNumber" onChange={onTextChange} className="form-control" type="text"></input></td>
                                            </tr>
                                            <tr>
                                                <td>Remarks</td>
                                                <td><textarea value={InsuranceData.Remarks} name="Remarks" onChange={onTextChange} rows="1" className="form-control"></textarea></td>
                                            </tr>
                                            <tr>
                                                <td>Attachment</td>
                                                <td>
                                                    {InsuranceData.UploadedFilePath === "" ? (<input type="file" name="insuranceFile"
                                                        className="form-control"
                                                        onChange={e => OnFileUpload(e)}
                                                        accept="image/jpeg, image/png, application/pdf"></input>) :
                                                        (<div><span style={{ cursor: "pointer", color: "#005582" }} onClick={() => GetInsuranceFile(InsuranceData.UploadedFilePath)}>{InsuranceData.UploadedFilePath}</span>
                                                            <span onClick={RemoveInsuranceFile} style={{ float: "right", cursor: "pointer" }}><FontAwesomeIcon style={{ paddingRight: "2px" }} icon={faTimes} /></span>
                                                        </div>)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="myModal3" className="modal" style={{ display: ShowPartnerInfo }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Partner Details</span>
                        <span className="close" onClick={GetPartnerInfo}>&times;</span>
                    </div>
                    {SelectedCustomer.Partner && (<table className="table">
                        <tbody style={{ fontSize: "1.1rem" }}>
                            <tr style={{ borderBottom: '1px solid #ccc' }}>
                                <td>Name</td>
                                <td>
                                    <span> {SelectedCustomer.Partner[0].Name}</span>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #ccc' }}>
                                <td>Address</td>
                                <td>
                                    {SelectedCustomer.Partner[0].AddressLine1},
                                    {SelectedCustomer.Partner[0].AddressLine2},
                                    {SelectedCustomer.Partner[0].City},
                                    {SelectedCustomer.Partner[0].PostalCode},
                                    {SelectedCustomer.Partner[0].State}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #ccc' }}>
                                <td>Contact</td>
                                <td>
                                    {SelectedCustomer.Partner[0].Contact}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #ccc' }}>
                                <td>GST Number</td>
                                <td>
                                    {SelectedCustomer.Partner[0].GSTNumber}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" className={`btn btn-default ${CurrentTheme}Focus`} onClick={GetPartnerInfo}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>)}
                </div>
            </div>
            <div id="displayFileModal" className="modal" style={{ display: displayFile, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Policy Document</span>
                        <span className="close" onClick={hideFileModal}>&times;</span>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <embed width="100%" height="500" alt="org Logo" src={FileData}></embed>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Insurance;